"use client";
import Link from "next/link";

import { ClickServer } from "shared-lib/clickserver";
import * as gtag from "shared-lib/gtag";
import {
  TRACKING_EVENTS,
  logStatsig,
  TRACKING_CATEGORIES,
} from "shared-lib/helpers/statsigFunctions";

import { getTagLink } from "@/lib/helpers/frontendFunctions";

const maxTagsToShow = 3;
export default function RecipeTagDisplay({ tags = [] as Tag[] }) {
  return (
    <div className="my-1 flex flex-wrap gap-2 py-2">
      {tags.slice(0, maxTagsToShow).map((tag) => {
        return (
          <Link
            key={tag.name}
            href={getTagLink(tag)}
            onClick={() => {
              logStatsig(TRACKING_EVENTS.recipe_tag_click, {
                tag_name: tag.name,
              });

              ClickServer.track(TRACKING_EVENTS.recipe_tag_click, {
                tag_name: tag.name,
              });

              gtag.event({
                action: TRACKING_EVENTS.recipe_tag_click,
                category: TRACKING_CATEGORIES.navigation,
                label: tag.name,
              });
            }}
            className="rounded-3xl border-2 border-theme-primary px-2 text-center text-xl font-bold"
          >
            {tag.name}
          </Link>
        );
      })}
    </div>
  );
}
